module.exports = __webpack_public_path__ + "static/V2-Carton-MineralSwimBagNew-3b3fd67da4a248c4c9479e8474be0b02.png";